/* global grecaptcha */

import 'modernizr'; // eslint-disable-line
import porta from 'porta';
import nl from 'porta/src/i18n/nl';
import '../vendor/bootstrap';

import tracking from '../modules/tracking';
import navigation from '../modules/navigation';
import search from '../modules/search';
import reviews from '../modules/reviews';
import cardReviews from '../modules/cardReviews';
import toTop from '../modules/toTop';
import filter from '../modules/filter/filter';
import callMeBack from '../modules/callMeBack';
import mediaItem from '../modules/mediaItem';
import homeSlider from '../modules/homeSlider';
import videoElement from '../modules/videoElement';
import tabs from '../modules/tabs';
import popover from '../modules/popover';
import videoOverlay from '../modules/videoOverlay';
import slider from '../modules/slider';
import toggle from '../modules/toggle';
import jumpToElement from '../modules/jumpToElement';
import datepicker from '../modules/datepicker';
import embedWrap from '../modules/embedWrap';
import whatsapp from '../modules/whatsapp';
import alert from '../modules/alert';
import accessibility from '../modules/accessibility';
import mediaRow from '../modules/mediaRow';
import controlledInput from '../modules/controlledInput';
import journeyHighlights from '../modules/journeyHighlights';
import traveler from '../modules/traveler';
import responsiveTable from '../modules/responsiveTable';
// import gaTracking from '../modules/gaTracking';

const general = () => {
  tracking.initialize();
  accessibility.initialize();
  navigation.initialize();
  search.initialize();
  reviews.initialize();
  cardReviews.initialize();
  toTop.initialize();
  filter.initialize();
  mediaItem.initialize();
  homeSlider.initialize();
  callMeBack.initialize();
  videoElement.initialize();
  tabs.initialize();
  popover.initialize();
  videoOverlay.initialize();
  slider.initialize();
  toggle.initialize();
  jumpToElement.initialize();
  datepicker.initialize();
  embedWrap();
  whatsapp.initialize();
  alert.initialize();
  mediaRow.initialize();
  controlledInput.initialize();
  journeyHighlights.initialize();
  traveler.initialize();
  responsiveTable.initialize();
  // gaTracking();

  porta({
    messages: nl,
    onValid: (formElement) => {
      const recaptcha = formElement.querySelector('.js-g-recaptcha');

      const event = new Event('porta:valid');
      formElement.dispatchEvent(event);

      if (recaptcha) {
        grecaptcha.execute(recaptcha.getAttribute('data-widget-id'));

        return false;
      }

      return true;
    },
  });
};

export default general;
